type SortingFunction<T> = (a: T, b: T) => number;

export const sortComparingMap: Record<number, SortingFunction<{ name: string }>> = {
	// sort by name
	2: (a, b) => a.name.localeCompare(b.name)
	// TODO: find out how to sort according to date via our own backend or Optix etc.
};
